import { Children, ReactNode } from 'react';
import { ListRowStyles } from '../../list-row.styles';
import { ContentColumnStyleProps } from './list-row-content-column.styles';
import { ListRowSubtitle } from './list-row-subtitle';
import { ListRowTertiaryTitle } from './list-row-tertiary-title';
import { ListRowTitle } from './list-row-title';

export const ContentColumn = ({ children, ...rest }: { children: ReactNode }) => {
  const styles = ListRowStyles.ContentColumn({
    textChildren: Children.toArray(children).length as ContentColumnStyleProps['textChildren'],
  });

  return (
    <div css={styles} className='content-column' {...rest}>
      {children}
    </div>
  );
};

ContentColumn.Title = ListRowTitle;
ContentColumn.Subtitle = ListRowSubtitle;
ContentColumn.TertiaryTitle = ListRowTertiaryTitle;
